export default __webpack_public_path__ + "static/media/sandboxes_free_tier.ea4ebdca.svg";